<div class="fixed-width support-tab only">
  <mat-tab-group *ngIf="tabIndex >=0" mat-stretch-tabs (selectedTabChange)="selectedTab($event)" [selectedIndex]="tabIndex">
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="{{licenceService.getKey('icon-support')}}">
        <span i18n>Welcome to support!</span>
      </ng-template>
      <app-static-content *ngIf="tabIndex===0" [data]="'support'"></app-static-content>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="{{licenceService.getKey('icon-faq')}}">
        <span i18n>Frequently Asked Questions</span>
      </ng-template>
      <app-static-content *ngIf="tabIndex===1" [data]="'faq'"></app-static-content>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="{{licenceService.getKey('icon-self-exclusion')}}">
        <span i18n>Self Exclusion</span>
      </ng-template>
      <app-static-content *ngIf="tabIndex===2" [data]="'self-exclusion'"></app-static-content>
    </mat-tab>
  </mat-tab-group>
</div>